import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/es';

moment.lang('es', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.es.js